export enum RelationshipCode {
  SoleOwner = "sole owner",
  JointOrFirst = "joint or primary",
  JointOrOther = "joint or other",
  Owner = "owner",
  Custodian = "custodian"
}
